// @flow
import React from 'react';
import styled from 'styled-components';
import '@reach/tabs/styles.css';
import { TabsTheme } from './theme';
import ArrowLeftIcon from '../../icons/arrow_left';
import ArrowRightIcon from '../../icons/arrow_right';
import type { ScrollDirection } from './use_side_scroll';
import { Body } from '../../typography';

type Props = {
  canScrollLeft: boolean,
  canScrollRight: boolean,
  sideScroll: (direction: ScrollDirection) => void,
};

const ScrollControls = (props: Props) => {
  const { canScrollLeft, canScrollRight, sideScroll } = props;

  const arrowProps = {
    color: TabsTheme.default.arrowColor,
    width: 15,
    strokeWidth: 0.5,
  };

  const ScrollBackArrow = (
    <ScrollArrow direction="left" onClick={() => sideScroll('left')}>
      <Body>
        <ArrowLeftIcon {...arrowProps} />
      </Body>
    </ScrollArrow>
  );

  const ScrollForwardArrow = (
    <ScrollArrow direction="right" onClick={() => sideScroll('right')}>
      <Body>
        <ArrowRightIcon {...arrowProps} />
      </Body>
    </ScrollArrow>
  );

  return (
    <ScrollControlsWrapper>
      {canScrollLeft && ScrollBackArrow}
      {canScrollRight && ScrollForwardArrow}
    </ScrollControlsWrapper>
  );
};

const ScrollArrow = styled.button`
  position: absolute;
  ${({ direction }) => `${direction}: 0`};
  width: 1.5rem;
  height: 2.5rem;
  padding: 0;
  background: ${TabsTheme.default.arrowBackground};
  border: none;
  cursor: pointer;

  svg {
    padding: 0.25rem;
    margin-top: 0.25rem;
    border-radius: 1rem;

    &:hover {
      background: ${TabsTheme.hover.arrowHighlight};
    }
  }
`;

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const ScrollControlsWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`;

export default ScrollControls;
